import type { ComponentProps } from 'react';
import { FieldInfo, Select, useFieldContext } from './shared';
import { Label } from '../label';
import { getTranslatedCountry, type Locale } from '@worldcoo/monolith/core';
import { countries } from '@worldcoo/monolith/forms/countries';

const priorityCountries = countries.filter((c) => c.priority === 1);
const nonPriorityCountries = countries.filter((c) => c.priority >= 2);

export default function CountryField({
	label,
	locale = 'en',
	className,
	...props
}: ComponentProps<'select'> & {
	label: string;
	locale?: Locale;
	variant?: 'default' | 'outline';
}) {
	const field = useFieldContext<string>();

	return (
		<div className={className}>
			<div className="text-muted-foreground relative">
				{label && (
					<Label
						data-slot="form-label"
						data-error={field.state.meta.isTouched && !field.state.meta.isValid}
						className="data-[error=true]:text-destructive floating pointer-events-none w-full truncate px-3.5 py-[17px]"
						htmlFor={field.name}
					>
						{label}
					</Label>
				)}
				<Select
					id={field.name}
					name={field.name}
					value={field.state.value}
					onBlur={field.handleBlur}
					onChange={(e) => field.handleChange(e.target.value)}
					{...props}
				>
					<option value=""></option>
					{priorityCountries.map(({ country, name }) => (
						<option key={country} value={country}>
							{getTranslatedCountry(country, locale) ?? name}
						</option>
					))}

					<optgroup label="---">
						{nonPriorityCountries.map(({ country, name }) => (
							<option key={country} value={country}>
								{getTranslatedCountry(country, locale) ?? name}
							</option>
						))}
					</optgroup>
				</Select>
			</div>
			<FieldInfo fieldState={field.state} />
		</div>
	);
}
